import styled from 'styled-components';

import { lighten } from 'utils/colours';

import { Switch as AntdSwitch } from 'antd';

const Switch = styled(AntdSwitch)`
    & .ant-switch-inner {
        color: #fff;
    }
    &&.ant-switch-checked.ant-switch-loading .ant-switch-loading-icon {
        color: ${({ theme }) => theme.colour.primary};
    }
    &:focus {
        box-shadow: ${({ theme }) => `0 0 0 2px ${lighten(theme.colour.primary, 40)}`};
    }
    &.ant-switch-checked {
        background-color: ${({ theme }) => theme.colour.primary};
    }
`;

export default Switch;
